import React from "react";

function MqttIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.30203 13.6175C1.98054 13.296 1.79992 12.8599 1.79992 12.4053C1.79992 11.9506 1.98054 11.5146 2.30203 11.1931L10.7873 2.70781C11.1088 2.38632 11.5448 2.20571 11.9995 2.20571C12.4541 2.20571 12.8902 2.38632 13.2117 2.70781L21.697 11.1931C22.0184 11.5146 22.1991 11.9506 22.1991 12.4053C22.1991 12.8599 22.0184 13.296 21.697 13.6175L13.2117 22.1027C12.8902 22.4242 12.4541 22.6048 11.9995 22.6048C11.5448 22.6048 11.1088 22.4242 10.7873 22.1027L2.30203 13.6175Z"
        stroke="#667085"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.06148 12.7083C7.22885 12.541 7.22885 12.2696 7.06148 12.1022C6.89411 11.9349 6.62276 11.9349 6.45539 12.1022C6.28802 12.2696 6.28802 12.541 6.45539 12.7083C6.62276 12.8757 6.89411 12.8757 7.06148 12.7083Z"
        fill="#667085"
        stroke="#667085"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3037 7.46613C12.471 7.29876 12.471 7.02741 12.3037 6.86004C12.1363 6.69267 11.8649 6.69267 11.6976 6.86004C11.5302 7.02741 11.5302 7.29876 11.6976 7.46613C11.8649 7.6335 12.1363 7.6335 12.3037 7.46613Z"
        fill="#667085"
        stroke="#667085"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5459 12.7083C17.7132 12.541 17.7132 12.2696 17.5459 12.1022C17.3785 11.9349 17.1071 11.9349 16.9398 12.1022C16.7724 12.2696 16.7724 12.541 16.9398 12.7083C17.1071 12.8757 17.3785 12.8757 17.5459 12.7083Z"
        fill="#667085"
        stroke="#667085"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3037 17.9515C12.471 17.7841 12.471 17.5128 12.3037 17.3454C12.1363 17.178 11.8649 17.178 11.6976 17.3454C11.5302 17.5128 11.5302 17.7841 11.6976 17.9515C11.8649 18.1189 12.1363 18.1189 12.3037 17.9515Z"
        fill="#667085"
        stroke="#667085"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.3037 12.7083C12.471 12.541 12.471 12.2696 12.3037 12.1022C12.1363 11.9349 11.8649 11.9349 11.6976 12.1022C11.5302 12.2696 11.5302 12.541 11.6976 12.7083C11.8649 12.8757 12.1363 12.8757 12.3037 12.7083Z"
        fill="#667085"
        stroke="#667085"
        strokeWidth="1.71429"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default MqttIcon;
